import { oneLine } from 'common-tags';
import { ErrorMessage, Field } from 'formik';

import type { FieldProps } from 'formik';
import type { FunctionComponent } from 'react';
import type { TextareaProps } from './types';

export const Textarea: FunctionComponent<TextareaProps> = ({
  className = '',
  name,
  label,
  disabled = false,
  placeholder,
  ...props
}: TextareaProps) => (
  <Field name={name}>
    {({ field, meta }: FieldProps) => (
      <div
        className={`flex flex-col gap-2 aria-disabled:opacity-40 ${className}`}
        aria-disabled={disabled}
      >
        {label && (
          <label
            htmlFor={name}
            className={oneLine`text-body text-body-s ${meta.error && meta.touched ? 'text-status-error' : ''} `}
          >
            {label}
          </label>
        )}

        <textarea
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          className={oneLine`text-body text-body-m placeholder:text-placeholder min-h-[50px] rounded-input ${
            meta.error && meta.touched
              ? 'border-status-error ring-status-error placeholder:text-status-error focus:border-status-error focus:ring-status-error active:border-status-error active:ring-status-error'
              : 'border-neutrals-500 placeholder:text-text-neutrals-500 focus:border-neutrals-900 focus:ring-neutrals-900 active:border-neutrals-500 active:ring-neutrals-900'
          } ${className} `}
          {...props}
          {...field}
        />

        <ErrorMessage name="textarea">
          {(msg) => (
            <div className="text-body text-body-s text-status-error">{msg}</div>
          )}
        </ErrorMessage>
      </div>
    )}
  </Field>
);

Textarea.displayName = 'Textarea';
